exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment-assign-form/equipment-assign-form.component.css
// module id = ../../../../../src/app/views/home/equipment/equipment-assign-form/equipment-assign-form.component.css
// module chunks = main